/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Grossmoic2Inputs */

const en_coinvestments_insights_col_grossmoic2 = /** @type {(inputs: Coinvestments_Insights_Col_Grossmoic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gross MOIC`)
};

/**
* | output |
* | --- |
* | "Gross MOIC" |
*
* @param {Coinvestments_Insights_Col_Grossmoic2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_grossmoic2 = /** @type {((inputs?: Coinvestments_Insights_Col_Grossmoic2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Grossmoic2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_grossmoic2(inputs)
});
export { coinvestments_insights_col_grossmoic2 as "coInvestments_insights_col_grossMoic" }